<div class="container ">
  <div class="row mt-5 mt-md-0 align-self-center">
    <div class=" col-12 col-md-7 text-center">
      <h1 class="big-display robotoslab d-none d-sm-block">DealPOS Multitenant</h1>
      <img src="//res.cloudinary.com/pos/image/upload/v1651119305/multitenantlogo.png" 
      alt="multitenant-image" class="img-fluid mt-5 pt-5 me-12" style="width: 85%;">
    </div>
    <div class="col-12 col-md-5 order-first order-md-last">
      <h1 class="big-display text-center my-5 py-5 robotoslab d-block d-sm-none">DealPOS Multitenant</h1>
      <div class="card">
        <div class="card-body pb-0">
          <div class="card-title mb-5">
            <h2 class="ms-2 font-weight-normal font-xl robotoslab">Sign In</h2>
          </div>
          <div class="form-label-group pb-5 mb-sm-2">
            <input type="text" [(ngModel)]="login.Username" name="Username" id="inputUsername" (input)="emitFieldChange('username')"
                   class="form-control text-start" placeholder="Username" required #username="ngModel"
                   (keydown)="onKeyDown($event)">
            <label for="inputUsername" class="text-start">Username</label>
            <ng-container *ngIf="username.invalid && (username.dirty || username.touched)">
              <span class="text-danger" *ngIf="username.errors?.['required']">
                Username is required.
              </span>
            </ng-container>
            <span class="text-danger" *ngIf="isExistUsername$ | async">
              Username is already exist.
            </span>
          </div>
          <div class="form-label-group pb-3 mb-sm-2">
            <input #passAutoFocus [type]="passwordType" [(ngModel)]="login.Password" name="Password" id="inputPassword"
                   class="form-control text-start" placeholder="Password" required #password="ngModel"
                   (keydown)="onKeyDown($event)">
            <label for="inputPassword" class="text-start">Password</label>
            <ng-container *ngIf="password.invalid && (password.dirty || password.touched)">
              <span class="text-danger" *ngIf="password.errors?.['required']">
                Password is required.
              </span>
            </ng-container>
            <i *ngIf="login.Password != ''" class="fa-solid fa-lg" (click)='hideShowPassword()'></i>
          </div>
        </div>

        <div class="card-footer border-top-0 mb-5">
          <div class="row">
            <div class="col-12 d-block justify-content-center align-items-center">
              <button class="btn btn-lg btn-primary font125rem robotoslab w-100" data-cy="login" type="submit"
                      (click)="DoLogin()">
                Log in
              </button>
              <div class="cursor robotoslab ms-3 mt-4 text-center font-12">
                <span>Don't have an account? <a routerLink="/register">Sign Up Here!</a></span>
              </div>
            </div>
            <div class="text-center">
              <a [routerLink]="['/ForgotPassword']">Forgot your password?</a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12 d-block d-md-none text-center">
      <p class="pt-1rem me-3">Powered by : </p>
      <a target="_blank" href="https://www.dealpos.com"><img
          src="https://res.cloudinary.com/pos/image/upload/POS/Images/Login/dealpos.png" alt="dealpos-logo"
          class="img-fluid"></a>
      <br />
      <a class="pt-1rem fst-italic" target="_blank"
        href="https://changelog.dealpos.com/?categories=cat_Cz4bnHn47xHsS&view=complete">Version 26.7.12</a>
    </div>
  </div>

</div>
<footer class="mx-5 pb-5 mb-5 d-none d-md-block">
  <div class="row justify-content-between align-items-center">
    <div class="col-auto d-inline-flex">
      <p class="pt-1rem me-3">Powered by : </p>
      <a target="_blank" href="https://www.dealpos.com"><img
          src="https://res.cloudinary.com/pos/image/upload/POS/Images/Login/dealpos.png" alt="dealpos-logo"
          class="img-fluid"></a>
    </div>
    <div class="col-auto">
      <a class="pt-1rem fst-italic" target="_blank"
        href="https://changelog.dealpos.com/?categories=cat_Cz4bnHn47xHsS&view=complete">Version 26.7.12</a>
    </div>
  </div>
</footer>
